import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST } from "../../../services/api";
import { apiUrl } from "../../../ApiHelper/ApiUrl";

export const getEvidence = createAsyncThunk(
    "evidence/getEvidence",
    async (controlId, { rejectWithValue }) => {
        try {            
            const response = await GET(
                "evidence", 
                `${apiUrl.evidence_details}/${controlId}`
            );

            return response?.data;
        } catch (error) {
            console.log("##error", error?.detail?.message || error?.message || "Something Went Wrong");
            return rejectWithValue(
                error?.detail?.message || error?.message || "Something Went Wrong"
            );
        }
    }
);

export const addEvidence = createAsyncThunk(
    "evidence/addEvidence",
    async (formData , { rejectWithValue }) => {
        try {            
            const response = await POST(
                "evidence",
                `${apiUrl.add_evidence}`,
                formData
            );

            return response?.data;
        } catch (error) {
            console.log("##error", error?.detail?.message || error?.message || "Something Went Wrong");
            return rejectWithValue(
                error?.detail?.message || error?.message || "Something Went Wrong"
            );
        }
    }
);

const evidenceSlice = createSlice({
    name: "evidence",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEvidence.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getEvidence.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload?.data;
            })
            .addCase(getEvidence.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default evidenceSlice.reducer;